import React from "react";
import { Button } from "antd";
import { CheckOutlined, DeleteOutlined } from "@ant-design/icons";
import filterStyles from "../filter.module.css";

export type FilterButtonGroupProps = {
  canApply: boolean;
  canClear: boolean;
  onClickApply: () => void;
  onClickClear: () => void;
};

const { ["button-group"]: buttonGroupClassName } = filterStyles;

export const FilterButtonGroup = ({
  canApply,
  canClear,
  onClickApply,
  onClickClear,
}: FilterButtonGroupProps) => {
  return (
    <div className={buttonGroupClassName}>
      <Button
        type="primary"
        size="small"
        icon={<CheckOutlined />}
        disabled={!canApply}
        onClick={onClickApply}
      >
        Apply
      </Button>
      <Button size="small" icon={<DeleteOutlined />} disabled={!canClear} onClick={onClickClear}>
        Clear
      </Button>
    </div>
  );
};
